import { ConnectedPosition, OverlayModule } from "@angular/cdk/overlay";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HelpComponent {

    @Input() content: graphHelp;

    overlayPositions: ConnectedPosition[] = [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom',
        }
    ]
    
    protected isOpen = false;
    protected timer: any;


    constructor() {}

    onMouseEnter() {
        this.isOpen = true;
        clearTimeout(this.timer);
    }

    onMouseLeave() {
        this.timer = setTimeout(() => {
            this.isOpen = false;
        }, 2000);
    }
}

export interface graphHelp {
    title: string;
    link: string;
}